import React from 'react';
import { isIAFCheckboxCheckableInsurance } from '../../lib/helpers/isCheckboxCheckable';

function IAFCustomCheckboxesInsurances({ data = {}, profile = {} }) {
  return (
    <>
      {isIAFCheckboxCheckableInsurance({ data, profile }) ? (
        <input
          type="checkbox"
          onChange={(e) => {
            e.stopPropagation();
            data.checked = !data.checked;
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
}

export default IAFCustomCheckboxesInsurances;
